import React, { useContext } from "react";
import { Navbar } from "react-bootstrap";
import "../../../assets/styles/topbar.scss";
import { COLOR_PRIMARY } from "../../../constants/colors";
import SmuBadge from "../../../utils/smu-badge/SmuBadge";
import SmuProfile from "../../../utils/smu-profile/SmuProfile";
import { StoreContext } from "../../../store/StoreContext";
import { IconHome } from "../../../icons/Icon";
import defaultAvatar from "../../../assets/images/user_default.png";
import { SMU_SELECTED_MENU } from "../../../constants";

const Topbar = () => {
  const { loggedUser, isAdmin } = useContext(StoreContext);
  

  const handleGoToPromotionalPortal = () => {
    // Check if SMU_SELECTED_MENU is active with a valid value (not null, empty, or 0)
    const savedSelectedMenu = localStorage.getItem(SMU_SELECTED_MENU);
    if (savedSelectedMenu) {
      try {
        const parsedMenu = JSON.parse(savedSelectedMenu);
        const menuId = parsedMenu?.id;
        // Check if menuId is valid (not null, empty, or 0)
        if (menuId !== null && menuId !== undefined && menuId !== "" && menuId !== 0) {
          // Clear the selected menu
          localStorage.removeItem(SMU_SELECTED_MENU);
        }
      } catch (err) {
        // If parsing fails, remove the invalid entry
        localStorage.removeItem(SMU_SELECTED_MENU);
      }
    }
  };

  const menu = [
    {
      id: 1,
      title: "Ir a portal promocional",
      path: "/promotional-portal/portal/",
      Icon: <IconHome color="#33383F" />,
      onClick: handleGoToPromotionalPortal,
    },
  ];

  return (
    <Navbar className="topbar-admin">
      <div className="d-flex mx-lg-4 w-100">
        <div className="d-flex my-auto h-100 pe-lg-4">
          <SmuBadge _className="rounded my-auto me-3" color={COLOR_PRIMARY} />
          <div>
            <div className="text-white text-truncate">
              <span className="h5 fw-bolder m-0 me-2">DASHBOARD /</span>
              <span className="fw-bolder">Portal Promocional</span>
            </div>
            <div className="tagline text-truncate">
              Dale un vistazo al resumen que hemos preparado para ti.
            </div>
          </div>
        </div>
        <SmuProfile
          avatar={loggedUser?.avatar || defaultAvatar}
          name={loggedUser?.name || loggedUser?.username}
          menu={menu}
          isAdmin={isAdmin}
          _className="ms-auto"
        />
      </div>
    </Navbar>
  );
};

export default Topbar;
